module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/private/tmp/metabase/release/41/metabase/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[0]!/private/tmp/metabase/release/41/metabase/frontend/src/metabase/lib/ga-metadata.js"));
    });
  });
}